import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/AuthContext";
import AuthContainer from "./auth-container";

export default function LoginRoute() {
  const { isAuthenticated } = useAuth();
  const location = useLocation() as any;

  // Prefer explicit redirect query param (survives OAuth full-page redirects)
  const search = typeof location?.search === "string" ? location.search : "";
  const params = new URLSearchParams(search);
  const qpRedirect = params.get("redirect") || undefined;

  // Fallback to router state from ProtectedRoute
  const from = location?.state?.from as
    | { pathname?: string; search?: string; hash?: string }
    | undefined;
  const stateRedirect = from
    ? `${from.pathname || "/"}${from.search || ""}${from.hash || ""}`
    : undefined;

  // Choose redirect target with basic safety (only allow same-origin paths)
  const rawTarget = qpRedirect || stateRedirect || "/";
  const safeTarget = rawTarget.startsWith("/") ? rawTarget : "/";

  if (isAuthenticated) {
    return <Navigate to={safeTarget} replace />;
  }

  return <AuthContainer />;
}
